'use strict';

var React = require('react');

var SvgOnlineStoreMinor = function SvgOnlineStoreMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2a1 1 0 1 1 0 2h-1a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2h-1a1 1 0 1 1 0-2h2a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-10Zm1.986 3.836a1 1 0 0 0-1.972.329c.223 1.339 1.565 3.835 4.986 3.835 3.42 0 4.763-2.496 4.986-3.835a1 1 0 1 0-1.972-.33c-.11.662-.835 2.165-3.014 2.165-2.18 0-2.903-1.504-3.014-2.164Z"
  }));
};

exports.SvgOnlineStoreMinor = SvgOnlineStoreMinor;
